import React from 'react';
import { Icon } from './Icon.js';
export const IconDroplet2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6.34317 19.5736C3.21897 16.3384 3.3758 11.2352 6.5 8L12 2L17.5 8C20.6242 11.2352 20.7811 16.3384 17.6569 19.5736C14.5327 22.8088 9.46736 22.8088 6.34317 19.5736Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 18C9.79086 18 8 16.2091 8 14", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconDroplet2.js.map